<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Nhóm AdHoc'">
          <template v-slot:toolbar>
            <div class="row">
              <div class="ml-3">
                <button
                  type="button"
                  class="btn btn-primary font-weight-bolder btn-sm"
                  @click="addNew"
                >
                  <i style="font-size: 1rem" class="flaticon2-add-1"></i>Tạo mới
                </button>
              </div>
            </div>
          </template>
          <template v-slot:preview>
            <b-alert show variant="light" class="mb-4 hint">
              Nhóm AdHoc là tập sản phẩm / danh mục dùng làm
              <strong>điều kiện kèm theo</strong> cho chương trình thưởng AdHoc.
              Ví dụ: thưởng khi bán điện thoại <em>kèm</em> sản phẩm thuộc nhóm này.
            </b-alert>

            <div class="col-md-12 mb-5 pl-0">
              <b-row>
                <b-col md="4" class="pl-0">
                  <b-input
                    size="sm"
                    placeholder="Tìm theo tên nhóm"
                    v-model="filter.keyword"
                    autocomplete="off"
                    v-on:input="debounceSearch"
                  ></b-input>
                </b-col>
                <b-col md="1">
                  <b-button
                    style="width: 70px"
                    variant="primary"
                    size="sm"
                    @click="onFilter"
                    >Lọc</b-button
                  >
                </b-col>
              </b-row>
            </div>

            <b-table
              :items="items"
              :fields="fields"
              bordered
              hover
              :busy="onLoading"
              show-empty
              empty-text="Chưa có nhóm AdHoc nào"
            >
              <template v-slot:table-busy>
                <vcl-table :speed="5" :animate="true" :columns="5"></vcl-table>
              </template>
              <template v-slot:cell(count)="row">
                {{ (page - 1) * PAGE_LIMIT + row.index + 1 }}
              </template>
              <template v-slot:cell(itemCount)="row">
                <b-badge variant="secondary">
                  {{ row.item.itemCount }} sản phẩm / danh mục
                </b-badge>
              </template>
              <template v-slot:cell(createdAt)="row">
                {{ displayDate(row.item.createdAt) }}
              </template>
              <template v-slot:cell(actions)="row">
                <div class="d-flex justify-content-center">
                  <b-dropdown size="sm" no-caret right>
                    <template slot="button-content">
                      <i
                        style="font-size: 1rem; padding-right: 0px"
                        class="flaticon2-settings"
                      ></i>
                    </template>
                    <b-dropdown-item @click="editItem(row.item)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i style="font-size: 1rem" class="flaticon2-pen"></i>
                        &nbsp; Chỉnh sửa
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="showDeleteAlert(row.item)"
                      v-if="checkPermission('REWARD_DELETE')"
                    >
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #d33"
                          class="flaticon2-rubbish-bin-delete-button"
                        ></i>
                        &nbsp; Xóa
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>

            <b-row>
              <b-col>
                <p class="mt-3 text-dark" style="font-weight: 500">
                  Tổng số nhóm: {{ totalItems }}
                </p>
              </b-col>
              <b-col>
                <b-pagination-nav
                  class="custom-pagination"
                  v-show="totalPages >= 2"
                  :link-gen="linkGen"
                  :number-of-pages="totalPages"
                  use-router
                  @change="fetchData"
                  align="right"
                  first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
                  prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
                  next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
                  last-class="page-item-last btn btn-icon btn-sm my-1"
                  page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
                >
                  <template v-slot:first-text>
                    <span><i class="ki ki-bold-double-arrow-back icon-xs"></i></span>
                  </template>
                  <template v-slot:prev-text>
                    <i class="ki ki-bold-arrow-back icon-xs"></i>
                  </template>
                  <template v-slot:next-text>
                    <i class="ki ki-bold-arrow-next icon-xs"></i>
                  </template>
                  <template v-slot:last-text>
                    <span class="text-info">
                      <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                    </span>
                  </template>
                </b-pagination-nav>
              </b-col>
            </b-row>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Danh sách Nhóm AdHoc — SRS F-06.
 * Nhóm AdHoc dùng làm ĐIỀU KIỆN kèm theo cho chương trình thưởng AdHoc,
 * cấu hình y hệt nhóm hoa hồng (item là Sản phẩm hoặc Danh mục).
 */
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import Swal from 'sweetalert2';
import debounce from 'debounce';
import { VclTable } from 'vue-content-loading';
import localData from '@/utils/saveDataToLocal';
import { TIME_TRIGGER } from '@/utils/constants';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';
import commissionReportMixin, { thStyle } from './commissionReport.mixin';

const PAGE_LIMIT = 10;

export default {
  components: { KTCodePreview, VclTable },
  mixins: [commissionReportMixin],
  data() {
    return {
      PAGE_LIMIT,
      onLoading: false,
      items: [],
      totalPages: 0,
      totalItems: 0,
      page: 1,
      filter: { keyword: '' },
      linkGen: (pageNum) => (pageNum === 1 ? '?' : `?page=${pageNum}`),
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: thStyle('6%'),
          tdClass: 'text-center',
        },
        { key: 'name', label: 'Tên nhóm', thStyle: thStyle('34%') },
        { key: 'description', label: 'Mô tả', thStyle: thStyle('30%') },
        {
          key: 'itemCount',
          label: 'Số item',
          thStyle: thStyle('16%'),
          tdClass: 'text-center',
        },
        { key: 'createdAt', label: 'Ngày tạo', thStyle: thStyle('10%') },
        { key: 'actions', label: '', thStyle: thStyle('4%') },
      ],
    };
  },
  created() {
    this.page = Number(this.$route.query.page) || 1;
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hoa hồng', route: '/commission/categories' },
      { title: 'Nhóm AdHoc' },
    ]);
  },
  methods: {
    checkPermission(condition) {
      return localData.checkPermission(condition);
    },
    debounceSearch: debounce(function () {
      this.onFilter();
    }, TIME_TRIGGER),
    onFilter() {
      this.page = 1;
      this.fetchData();
    },
    fetchData(pageNum) {
      if (pageNum) {
        this.page = pageNum;
      }
      this.onLoading = true;
      ApiService.setHeader();
      ApiService.query('commission-adhoc-categories', {
        params: {
          page: this.page,
          limit: PAGE_LIMIT,
          keyword: this.filter.keyword || undefined,
        },
      })
        .then(({ data }) => {
          this.items = data.data.items || [];
          this.totalItems = data.data.pagination.totalItems || 0;
          this.totalPages = data.data.pagination.totalPages || 0;
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không tải được danh sách nhóm'),
          );
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    addNew() {
      this.$router.push({ name: 'commission-upsert-adhoc-category' });
    },
    editItem(item) {
      this.$router.push({
        name: 'commission-upsert-adhoc-category',
        query: { id: item.id },
      });
    },
    showDeleteAlert(item) {
      Swal.fire({
        title: 'Xoá nhóm AdHoc',
        text: `Bạn có chắc muốn xoá nhóm "${item.name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Huỷ',
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
    deleteItem(item) {
      ApiService.setHeader();
      ApiService.delete(`commission-adhoc-categories/${item.id}`)
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.fetchData();
        })
        .catch((error) => {
          // BE chặn xoá nhóm đang được dùng làm điều kiện — hiện đúng lý do
          makeToastFaile(
            this.getErrorMessage(error, 'Không xoá được nhóm'),
          );
        });
    },
  },
};
</script>

<style scoped>
.hint {
  font-size: 13px;
  border: 1px dashed #d6d9e0;
}
</style>
